import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["data-name", "data-resume-required"]

import { ErrorMessage } from 'vee-validate';


export default /*#__PURE__*/_defineComponent({
  __name: 'InvalidMessage',
  props: {
    name: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ErrorMessage), { name: __props.name }, {
    default: _withCtx(({message}) => [
      _createElementVNode("p", {
        "data-name": __props.name,
        "data-resume-required": message?.startsWith('[resumeRequired]'),
        class: "p-login-form__error js-error-message"
      }, _toDisplayString(message?.replace('[resumeRequired]', '').replace('[recommendRequired]', '')), 9, _hoisted_1)
    ]),
    _: 1
  }, 8, ["name"]))
}
}

})